<template>
    <div class="pt-1 pb-1" v-if="!params.node.rowPinned">
        <div v-if="editable && !isEdit" @click="isEdit = !isEdit">
            <span class="referrer-title">{{ selectedReferrer }}</span>
        </div>
        <div v-else-if="editable && isEdit" class="d-flex align-items-start">
            <form-input
                v-if="isCreate"
                class="mb-0 mr-1"
                v-model="newReferrer"
            />
            <form-select
                v-else
                :options="referrerOptions"
                :value="selectedReferrer"
                @change="onChangeReferrer"
                class="mb-0 mr-1"
            />
            <b-button variant="primary" @click="updateReferrer" class="mr-1">
                <font-awesome-icon :icon="['fas', 'check']" />
            </b-button>
            <b-button @click="hideSelect" variant="danger">
                <font-awesome-icon :icon="['fas', 'xmark']"
            /></b-button>
        </div>
        <div v-else>
            <span>{{ selectedReferrer }}</span>
        </div>
    </div>
</template>

<script>
import formSelect from '../../generic/form-select/form-select.vue';
import FormInput from '../../generic/form-input/form-input.vue';
export default {
    components: { formSelect, FormInput },
    name: 'referrerCellRendererFramework',
    data() {
        return {
            isEdit: false,
            selectedReferrer: null,
            editable: null,
            isCreate: false,
            newReferrer: null,
        };
    },
    computed: {
        referrerOptions() {
            return [
                ...this.params.referrerOptionsGetter(),
                { value: 'new', text: 'Add New Referrer' },
            ];
        },
    },
    mounted() {
        this.selectedReferrer = this.params.value;
        this.editable = this.params.data.referrer?.editable;
    },
    methods: {
        updateReferrer() {
            this.params.updateReferrer &&
                this.params.updateReferrer(
                    this.isCreate ? this.newReferrer : this.selectedReferrer,
                    this.params.data.id
                );
            this.selectedReferrer = this.isCreate
                ? this.newReferrer
                : this.selectedReferrer;

            this.isEdit = false;
            this.isCreate = false;
            this.newReferrer = '';
        },
        onChangeReferrer(value) {
            if (value === 'new') {
                this.isCreate = true;
            }
            this.selectedReferrer = value;
        },
        hideSelect() {
            this.isEdit = false;
            this.selectedReferrer = this.params.data.referrer?.name;
        },
    },
};
</script>

<style scoped lang="scss">
.referrer-title {
    cursor: pointer;
    color: #0d47a1;
}
</style>